import React, { useEffect, useState } from 'react';
const INITIAL_SECONDS = 14 * 60 + 50;
export function CountdownTimer() {
  const [seconds, setSeconds] = useState(INITIAL_SECONDS);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) return INITIAL_SECONDS;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const minsStr = String(minutes).padStart(2, '0');
  const secsStr = String(secs).padStart(2, '0');
  return <span className="flex items-center gap-1 font-black text-xl md:text-2xl text-[#030303]" style={{
    fontFamily: 'Montserrat, sans-serif'
  }} data-id="element-1">
      <span className="bg-white px-2 py-0.5 rounded shadow-sm" data-id="element-2">{minsStr}</span>
      <span className="text-white" data-id="element-3">:</span>
      <span className="bg-white px-2 py-0.5 rounded shadow-sm" data-id="element-4">{secsStr}</span>
    </span>;
}